import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { jwtDecode } from "jwt-decode";

const initialState = {
  user: null,
  token: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,
};

// Async thunk for user login
export const userLogin = createAsyncThunk(
  "auth/userLogin",
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/auth/login`, credentials);
      return response.data; // Expecting { user, token } in response
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to log in. Please try again."
      );
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      state.error = null;
    },
    setToken: (state, action) => {
      const token = action.payload;
      state.token = token;
      // Decode the token and set the user
      if (token) {
        try {
          state.user = jwtDecode(token);
          state.isAuthenticated = true;
          
      } catch (error) {
          // console.error("Failed to decode token:", error);
          state.user = null;
          state.isAuthenticated = false;
          localStorage.clear()
          window.location.href="/login"
      }
      } else {
        state.user = null;
        state.isAuthenticated = false;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(userLogin.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(userLogin.fulfilled, (state, action) => {
        state.isLoading = false;
        state.token = action.payload.token;
        // Decode the token and set user
        state.user = jwtDecode(action.payload.token);
        state.isAuthenticated = true;
      })
      .addCase(userLogin.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { logout, setToken } = authSlice.actions;
export default authSlice.reducer;
